import CrudRequest from '@/app/arch/components/crud/CrudRequest';

export default class LegalSearchRequest extends CrudRequest {
  static baseUrl() {
    return '/account//legal-search-history';
  }
}
